import { FC } from "react";
import { Container } from "@mui/material";
import { ClientsDashboard } from "../components";
import { Navigate } from "react-router-dom";

type TRole = {
  role: number;
};

const Client: FC<TRole> = (props) => {
  const role = props.role;
  return (
    <>
      <Container maxWidth="lg">
        {role === 1 || role === 2 ? <ClientsDashboard /> : <Navigate to="/projects" />}
      </Container>
    </>
  );
};
export default Client;
